<template>
  <div>
    <form
      @submit.prevent="submit"
      class="d-flex flex-column form"
      novalidate
      autocomplete="off"
    >
      <v-text-field
        rounded
        :label="$t('programCode')"
        outlined
        class="flex-grow-0 mb-2"
        dense
        type="email"
        v-model="roomName"
        color="primary"
      ></v-text-field>

      <v-btn
        rounded
        outlined
        color="primary"
        class="align-self-center custom-rounded-btn"
        depressed
        type="submit"
        :loading="loader"
        :disabled="!roomName"
        >{{ $t('startProgram') }}</v-btn
      >
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import i18n from "../../locales/i18n";
export default {
  data() {
    return {
      roomName: "",
      loader: false,
    };
  },
  methods: {
    ...mapActions(["connectToRoom"]),
    async submit() {
      try {
        this.loader = true;
        await this.connectToRoom(this.roomName);
        this.loader = false;
        this.$router.push({ path: `/${i18n.locale}/room` });
      } catch (e) {
        this.loader = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  width: 250px;
}

.custom-rounded-btn {
  border-radius: 9999px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  height: 40px !important;
  font-size: 16px !important;
}
</style>